import { render, staticRenderFns } from "./ny_zhengce.vue?vue&type=template&id=4fa9db85&scoped=true&"
import script from "./ny_zhengce.vue?vue&type=script&lang=js&"
export * from "./ny_zhengce.vue?vue&type=script&lang=js&"
import style0 from "./ny_zhengce.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ny_zhengce.vue?vue&type=style&index=1&id=4fa9db85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa9db85",
  null
  
)

export default component.exports